import React from 'react';
import classNames from 'classnames';

import { Link } from 'react-router-dom';
import { getBtnClass, ButtonVariant, ButtonColour } from './getBtnClass';

interface Props {
  children: React.ReactNode;
  id?: string;
  to: string;
  target?: string;
  onClick?: () => void;
  variant?: ButtonVariant;
  colour?: ButtonColour;
  className?: string;
  disabled?: boolean;
}

const ButtonLink: React.FC<Props> = (props) => {
  const {
    children,
    id,
    to,
    target,
    onClick,
    variant = 'primary',
    colour = 'primary',
    className = '',
    disabled = false,
  } = props;

  const btnClass = classNames(
    getBtnClass(variant, colour),
    'no-underline data-[enabled=false]:pointer-events-none',
    className,
  );

  return (
    <Link
      id={id}
      to={to}
      target={target}
      onClick={onClick}
      className={btnClass}
      data-enabled={!disabled}
    >
      {children}
    </Link>
  );
};

export default ButtonLink;
